import React from "react";

import { CircularProgress, Paper, Typography, Fab, Box } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import DownloadIcon from "@/components/Icons/DownloadIcon";
import PdfIcon from "@/components/Icons/PdfIcon";
import RawIcon from "@/components/Icons/RawIcon";
import If from "@/components/layout/If";
import Padding from "@/components/layout/Padding";
import { ChatMessageAttachmentFragment } from "@/gql/graphql";

interface Props {
  attachment: ChatMessageAttachmentFragment;
  isUploaded: boolean;
}

const useStyles = makeStyles()((theme) => ({
  root: {
    borderRadius: theme.spacing(2),
    backgroundColor: "#EDF0F5",
  },
  icon: {
    width: 34,
    height: 34,
  },
  filename: {
    fontSize: 16,
    color: "#0B1B26",
  },
  download: {
    width: 38,
    height: 38,
    fontSize: 17,
    boxShadow: "none",
    "&:active": {
      boxShadow: "none",
    },
  },
  progress: {
    width: "38px !important",
    height: "38px !important",
  },
}));

const AttachmentFile: React.FC<Props> = ({ attachment, isUploaded }) => {
  const { classes } = useStyles();

  return (
    <Paper className={classes.root} elevation={0}>
      <Padding all={3}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
            }}
          >
            <If
              condition={attachment.contentType === "application/pdf"}
              then={<PdfIcon className={classes.icon} />}
              else={<RawIcon className={classes.icon} />}
            />
            <Typography className={classes.filename}>
              {attachment.filename}
            </Typography>
          </Box>
          <If
            condition={isUploaded}
            then={
              <Fab
                className={classes.download}
                color="primary"
                aria-label="download"
                component="a"
                href={attachment.downloadUrl}
                download={attachment.filename}
                target="_blank"
              >
                <DownloadIcon fontSize="inherit" />
              </Fab>
            }
            else={<CircularProgress className={classes.progress} />}
          />
        </Box>
      </Padding>
    </Paper>
  );
};

export default AttachmentFile;
